"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var StudentPastDrivesController = /** @class */ (function () {
    function StudentPastDrivesController(UsersModel, UserService) {
        this.UsersModel = UsersModel;
        this.currentPage = 1;
        this.classes = [];
        this.attendance = [];
        this.date = new Date();
        this.student = UserService.getCurrentUser();
        this.options = {
            page: this.currentPage,
            id: this.student.id,
            drivesBefore: (0, time_1.toYMD)(new Date()),
            page_results: true,
        };
        this.loading = true;
        this.handleStudentDrives = this.handleStudentDrives.bind(this);
        this.handlePastClasses = this.handlePastClasses.bind(this);
        UsersModel.getStudentDrives(this.options).then(this.handleStudentDrives);
        UsersModel.getStudentPastClasses({ id: this.student.id }).then(this.handlePastClasses);
    }
    StudentPastDrivesController.prototype.pageChanged = function () {
        this.options.page = this.currentPage;
        this.UsersModel.getStudentDrives(this.options).then(this.handleStudentDrives);
        this.UsersModel.getStudentPastClasses({ id: this.student.id }).then(this.handlePastClasses);
    };
    StudentPastDrivesController.prototype.handleStudentDrives = function (response) {
        this.totalItems = response.drives.total;
        this.drives = response.drives.map(function (drive) {
            if (drive.observation === true) {
                drive.type.name = drive.type.name + " (Observation)";
            }
            return drive;
        });
    };
    StudentPastDrivesController.prototype.handlePastClasses = function (response) {
        this.classes = response.classes.map(function (classDate) {
            //matches classes with attendance... this could probably be moved to the back end
            classDate.attendance = response.attendance.find(function (el) { return el.class_id === classDate.id; });
            return classDate;
        });
        this.loading = false;
    };
    return StudentPastDrivesController;
}());
StudentPastDrivesController.$inject = ["UsersModel", "UserService"];
exports.default = StudentPastDrivesController;
